module.exports = __webpack_public_path__ + "img/HHcszorolap2023.dae5b496.jpg";